// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewImportFromLocalFilesSelector__container___O2gIK {
    width: 95%;
}

.NewImportFromLocalFilesSelector__title___GJ0zX {
    margin-bottom: 1.6rem;
    padding-bottom: 0.4rem;
    border-bottom: var(--control-border-width) solid var(--color-bg-ghost);
}

.NewImportFromLocalFilesSelector__card___yA54i {
    display: flex;
    align-items: center;

    padding: 1.6rem;

    border: var(--control-border-width) solid var(--color-bg-border);
    border-radius: var(--space-xs);
}

.NewImportFromLocalFilesSelector__selectedCard___8aPK3:hover {
    cursor: pointer;
    background: var(--color-control-bg-clear-hover);
    border-color: var(--color-control-bg-border-secondary-hover);
}

.NewImportFromLocalFilesSelector__disabledCard____eqnq {
    background: var(--color-bg-ghost);
}

.NewImportFromLocalFilesSelector__sourcesWrapper___gRPrp {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.NewImportFromLocalFilesSelector__sourcesContainer___g6HJU {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    row-gap: 5rem;
    align-items: center;
    justify-content: center;
}

.NewImportFromLocalFilesSelector__searchText___Yj8_1 {
    margin-bottom: 1.6rem;
}

.NewImportFromLocalFilesSelector__globalSearchContainer____eksa {
    margin-top: 1.6rem;
    margin-bottom: 0.8rem;
}

.NewImportFromLocalFilesSelector__globalSearchField___zFfPr {
    flex-grow: 1;
}

.NewImportFromLocalFilesSelector__findBtn___yTIhD {
    margin-right: 0.8rem;
}

.NewImportFromLocalFilesSelector__icon___MF7Qa {
    margin-right: 1.2rem;
}

.NewImportFromLocalFilesSelector__itemText___jrEHX {
    padding-bottom: 0.4rem;
}

.NewImportFromLocalFilesSelector__link___YnaXU {
    text-decoration: none;
}

.NewImportFromLocalFilesSelector__gridItem___lbR1m {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/OverallImport/NewImportSourceSelectors/NewImportFromLocalFilesSelector.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sEAAsE;AAC1E;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,eAAe;;IAEf,gEAAgE;IAChE,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,+CAA+C;IAC/C,4DAA4D;AAChE;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;;IAE9B,WAAW;AACf","sourcesContent":[".container {\n    width: 95%;\n}\n\n.title {\n    margin-bottom: 1.6rem;\n    padding-bottom: 0.4rem;\n    border-bottom: var(--control-border-width) solid var(--color-bg-ghost);\n}\n\n.card {\n    display: flex;\n    align-items: center;\n\n    padding: 1.6rem;\n\n    border: var(--control-border-width) solid var(--color-bg-border);\n    border-radius: var(--space-xs);\n}\n\n.selectedCard:hover {\n    cursor: pointer;\n    background: var(--color-control-bg-clear-hover);\n    border-color: var(--color-control-bg-border-secondary-hover);\n}\n\n.disabledCard {\n    background: var(--color-bg-ghost);\n}\n\n.sourcesWrapper {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n}\n\n.sourcesContainer {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    row-gap: 5rem;\n    align-items: center;\n    justify-content: center;\n}\n\n.searchText {\n    margin-bottom: 1.6rem;\n}\n\n.globalSearchContainer {\n    margin-top: 1.6rem;\n    margin-bottom: 0.8rem;\n}\n\n.globalSearchField {\n    flex-grow: 1;\n}\n\n.findBtn {\n    margin-right: 0.8rem;\n}\n\n.icon {\n    margin-right: 1.2rem;\n}\n\n.itemText {\n    padding-bottom: 0.4rem;\n}\n\n.link {\n    text-decoration: none;\n}\n\n.gridItem {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewImportFromLocalFilesSelector__container___O2gIK`,
	"title": `NewImportFromLocalFilesSelector__title___GJ0zX`,
	"card": `NewImportFromLocalFilesSelector__card___yA54i`,
	"selectedCard": `NewImportFromLocalFilesSelector__selectedCard___8aPK3`,
	"disabledCard": `NewImportFromLocalFilesSelector__disabledCard____eqnq`,
	"sourcesWrapper": `NewImportFromLocalFilesSelector__sourcesWrapper___gRPrp`,
	"sourcesContainer": `NewImportFromLocalFilesSelector__sourcesContainer___g6HJU`,
	"searchText": `NewImportFromLocalFilesSelector__searchText___Yj8_1`,
	"globalSearchContainer": `NewImportFromLocalFilesSelector__globalSearchContainer____eksa`,
	"globalSearchField": `NewImportFromLocalFilesSelector__globalSearchField___zFfPr`,
	"findBtn": `NewImportFromLocalFilesSelector__findBtn___yTIhD`,
	"icon": `NewImportFromLocalFilesSelector__icon___MF7Qa`,
	"itemText": `NewImportFromLocalFilesSelector__itemText___jrEHX`,
	"link": `NewImportFromLocalFilesSelector__link___YnaXU`,
	"gridItem": `NewImportFromLocalFilesSelector__gridItem___lbR1m`
};
export default ___CSS_LOADER_EXPORT___;
